import React from 'react';
import { SELF_RATE_SKILL_LEVELS } from 'screens/FindOnboarding/types';
import classNames from 'styles/utils/classNames';

const FIELD_ID = 'skill-level';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

/**
 * Categorical self-rated skill level asked when registering for a SOCIAL event, so
 * the organizer can group players sensibly. Saved to the player's profile.
 *
 * `required` is what blocks the step — the surrounding form relies on native
 * validation the same way the event-group select does, so there's no separate
 * error state to manage. The field only renders for sports that have a skill level
 * column, so it never blocks a registration it can't apply to.
 */
export default function SkillLevelQuestion({ value, onChange }: Props) {
  return (
    <div className="mt-ds-xl">
      <label htmlFor={FIELD_ID} className="typography-product-subheading mb-ds-sm block">
        What&apos;s your skill level?
      </label>
      <p className="typography-product-caption mb-ds-lg text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        Helps the organizer create groups
      </p>
      <select
        id={FIELD_ID}
        name="skillLevelId"
        required
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className={classNames(
          'input-form w-full cursor-pointer pr-10', // pr-10 accounts for the arrow
          value
            ? 'text-color-text-lightmode-primary dark:text-color-text-darkmode-primary'
            : 'text-color-text-lightmode-placeholder dark:text-color-text-darkmode-placeholder',
        )}
      >
        <option value="" disabled>
          Select your skill level
        </option>
        {SELF_RATE_SKILL_LEVELS.map((level) => (
          <option key={level.value} value={level.value} className="cursor-pointer">
            {level.label}
          </option>
        ))}
      </select>
    </div>
  );
}
